var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgViewAgenda = function SvgViewAgenda(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50001 8.5H22.6667C23.125 8.5 23.5 8.875 23.5 9.33333V14.3333C23.5 14.7917 23.125 15.1667 22.6667 15.1667H8.50001C8.04167 15.1667 7.66667 14.7917 7.66667 14.3333V9.33333C7.66667 8.875 8.04167 8.5 8.50001 8.5ZM8.50001 16.8333H22.6667C23.125 16.8333 23.5 17.2083 23.5 17.6667V22.6667C23.5 23.125 23.125 23.5 22.6667 23.5H8.50001C8.04167 23.5 7.66667 23.125 7.66667 22.6667V17.6667C7.66667 17.2083 8.04167 16.8333 8.50001 16.8333Z",
    fill: "#637381"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViewAgenda, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/viewAgenda.f90f8e08.svg";
export { ForwardRef as ReactComponent };